import { Component, OnInit } from '@angular/core';
import { AppService } from '@nk/access-block';
import { MessageQueueService } from '@nk/ui-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'nk-footer',
  templateUrl: './app-footer.component.html',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppFooterComponent implements OnInit {
  public year = new Date().getFullYear();
  public applicationVersion$: Observable<string>;
  public mergedMessageString$: Observable<string | null>;

  constructor(
    private _appService: AppService,
    private _messageQueueService: MessageQueueService,
  ) {}

  public ngOnInit(): void {
    this.applicationVersion$ = this._appService.configCache.get('application_version').pipe(
      map((applicationVersion) => {
        return applicationVersion && typeof applicationVersion.config_value === 'string'
          ? applicationVersion.config_value
          : '';
      }),
    );
    this.mergedMessageString$ = this._messageQueueService.messages$.pipe(
      map((messageQueue) => {
        if (messageQueue && messageQueue.length) {
          return messageQueue.map((a) => a.message).join(', ');
        } else {
          return null;
        }
      }),
    );
  }
}
